import { FormattedMessage } from 'react-intl';

import { usePaymentIntentContext } from '@/providers/PaymentIntentProvider/context';
import InsuranceSVG from '@/svg/Insurance.svg';
import { API } from '@/utils/apiConstants';

import { Link } from './Link';

export const ShippingInsuranceCard = () => {
  const {
    data: { insurance_coverage },
  } = usePaymentIntentContext();

  return (
    <section className="flex items-center gap-4">
      <div className="flex shrink-0 size-5 items-center justify-center">
        <img src={InsuranceSVG} alt="insurance" width="15" height="17" />
      </div>
      <div>
        <div>
          <h4 className="m-0 leading-[150%] text-ink-900 font-bold flex gap-1">
            <FormattedMessage id="shipping-insurance.title" />
            <Link href={API.supportUrl}>
              <FormattedMessage id="global.learn-more" />
            </Link>
          </h4>
        </div>
        <em className="text-ink-500">
          <FormattedMessage
            id="shipping-insurance.message"
            values={{
              amount: insurance_coverage,
            }}
          />
        </em>
      </div>
    </section>
  );
};
